import type {SocialLink} from 'store/slices/settings/types';
import {SocialLinkType} from 'store/slices/settings/types';
import type {Organization} from 'store/slices/user/types';

const DOMAIN_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/;

export const validDomain = (domain: string): boolean => {
  if (!domain) return true;
  return DOMAIN_PATTERN.test(domain);
};

export const createSocialLinksFromOrg = (org: Organization): SocialLink[] => {
  const socials: SocialLink[] = [];

  const socialMappings = [
    {field: 'facebook', type: SocialLinkType.Facebook},
    {field: 'instagram', type: SocialLinkType.Instagram},
    {field: 'twitter', type: SocialLinkType.Twitter},
    {field: 'youtube', type: SocialLinkType.Youtube},
    {field: 'homepage', type: SocialLinkType.Other},
  ];

  socialMappings.forEach(({field, type}) => {
    if (org[field as keyof Organization]) {
      socials.push({
        type,
        link: org[field as keyof Organization] as string,
      });
    }
  });

  return socials;
};
